module.exports = __webpack_public_path__ + "img/cupboard.38def972.svg";